import React from 'react';
import { Plus, Trash2 } from 'lucide-react';
import { Textarea } from '../../ui/textarea';

export default function ListEditor({ value = [], onChange, addLabel = 'Add point', disabled, testId, rows = 2 }) {
  const set = (i, v) => onChange(value.map((x, j) => (j === i ? v : x)));
  return (
    <div className="space-y-2" data-testid={testId}>
      {value.map((item, i) => (
        <div key={i} className="flex gap-2 items-start">
          <span className="mt-2.5 w-1.5 h-1.5 rounded-full bg-fuchsia-400 shrink-0" />
          <Textarea value={item} rows={rows} disabled={disabled} onChange={(e) => set(i, e.target.value)}
            className="text-sm" data-testid={`${testId}-item-${i}`} />
          {!disabled && (
            <button type="button" onClick={() => onChange(value.filter((_, j) => j !== i))}
              className="p-2 rounded-lg hover:bg-rose-50 text-rose-500" data-testid={`${testId}-remove-${i}`} aria-label="Remove">
              <Trash2 className="w-4 h-4" />
            </button>
          )}
        </div>
      ))}
      {!disabled && (
        <button type="button" onClick={() => onChange([...value, ''])}
          className="inline-flex items-center gap-1 text-xs font-semibold text-fuchsia-700 hover:text-fuchsia-900" data-testid={`${testId}-add`}>
          <Plus className="w-3.5 h-3.5" /> {addLabel}
        </button>
      )}
    </div>
  );
}
